import { render, staticRenderFns } from "./detail-dianping.vue?vue&type=template&id=d1466904&"
import script from "./detail-dianping.vue?vue&type=script&lang=js&"
export * from "./detail-dianping.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports